import React, { useState, useEffect } from "react";
import s from "./FormSelect.module.scss";
import { countryCode } from "../../utils/constants";
import { ErrorIcon } from "../../assets/icon";
import SearchInput from "../SearchInput/SearchInput";
import { sortingCountry } from "../../utils/formConfig";

const FormSelect = ({ label, errors, register, name, required }) => {
  const [open, setOpen] = useState(false);
  const [countries, setCountry] = useState(countryCode);
  const [active, setActive] = useState(null);

  const handleOpen = () => setOpen(!open);

  const hadleSearch = (e) => {
    e.preventDefault();

    const {
      target: { value },
    } = e;

    setCountry(
      countryCode.filter((country) => country.name.toLowerCase().match(value))
    );
  };

  useEffect(() => {
    if (active !== null) {
      setOpen(!open);
    }
  }, [active]);

  return (
    <div className={s.form_group}>
      {label && (
        <label className={s.label} htmlFor={name}>
          {label} {required && <span style={{ color: "#2079CB" }}>*</span>}
        </label>
      )}
      <div className={s.select_box}>
        <button
          type="button"
          name={name}
          ref={!!register ? register : null}
					value={active}
          className={s.button}
          onClick={handleOpen}
        >
          {active ? JSON.parse(active).name : "Choose a country"}
        </button>
        {open && (
          <div className={s.select_box} style={{}}>
            <SearchInput onChange={hadleSearch} label="Search country" />
            <div>
              <select
                onChange={({ target: { value } }) =>
                  setActive(value)
                }
                size={countryCode.length}
              >
                {sortingCountry(countries).map((country, index) => (
                  <option key={index} value={JSON.stringify(country)}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        <div className={s.error_icon}>
          {!!errors && errors[name]?.message && <ErrorIcon />}
        </div>
      </div>

      <div className={s.error}>{!!errors && errors[name]?.message}</div>
    </div>
  );
};

export default FormSelect;
